import React from 'react'

const MoonIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.14264 12.4167C5.32598 12.4167 4.56035 12.2611 3.84577 11.95C3.13118 11.6389 2.50896 11.2184 1.9791 10.6885C1.44924 10.1587 1.02875 9.53646 0.717643 8.82187C0.406532 8.10729 0.250977 7.34167 0.250977 6.525C0.250977 5.10556 0.70306 3.85382 1.60723 2.76979C2.51139 1.68576 3.66348 1.0125 5.06348 0.75C4.88848 1.7125 4.94195 2.65313 5.22389 3.57188C5.50584 4.49062 5.99195 5.29514 6.68223 5.98542C7.3725 6.67569 8.17702 7.16181 9.09577 7.44375C10.0145 7.72569 10.9551 7.77917 11.9176 7.60417C11.6649 9.00417 10.994 10.1562 9.90514 11.0604C8.81625 11.9646 7.56209 12.4167 6.14264 12.4167ZM6.14264 11.25C6.9982 11.25 7.79056 11.0361 8.51973 10.6083C9.24889 10.1806 9.8225 9.59236 10.2406 8.84375C9.40445 8.76597 8.61209 8.55451 7.86348 8.20937C7.11487 7.86424 6.44403 7.39514 5.85098 6.80208C5.25792 6.20903 4.78639 5.53819 4.43639 4.78958C4.08639 4.04097 3.87737 3.24861 3.80931 2.4125C3.0607 2.83056 2.47493 3.4066 2.05202 4.14062C1.6291 4.87465 1.41764 5.66944 1.41764 6.525C1.41764 7.8375 1.87702 8.95312 2.79577 9.87187C3.71452 10.7906 4.83014 11.25 6.14264 11.25Z'
      fill='currentColor'
    />
  </svg>
)

export default MoonIcon
